import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import get from 'lodash/get';
import lowerFirst from 'lodash/lowerFirst';
const VAR_RE = /{{\s*(\w+)\s*(?:\s*\|\s*([^}]+))?\s*}}/g;
const LINK_RE = /{%%\s+(\w+)\s+(\w+)\s+%%}([\s\S]+?){%%\s+end(?:\w+)\s+%%}/gi;
const renderLink = (attribute, hrefKey, inner, values = {}, linkRenderers = undefined)=>{
    if (attribute !== 'link') return inner;
    const children = inner.trim();
    const customRenderer = linkRenderers === null || linkRenderers === void 0 ? void 0 : linkRenderers[hrefKey];
    if (customRenderer) {
        return customRenderer(values, children);
    }
    return `#${hrefKey}`;
};
const renderVariable = (variableKey, variableFlag, values = {})=>{
    const key = variableKey.trim();
    const flags = (variableFlag !== null && variableFlag !== void 0 ? variableFlag : '').split('|').map((s)=>s.trim().toLowerCase()).filter(Boolean);
    const value = get(values, lowerFirst(key), '');
    let output = value;
    if (flags.includes('bold')) output = /*#__PURE__*/ _jsx("b", {
        children: output
    });
    if (flags.includes('italic')) output = /*#__PURE__*/ _jsx("i", {
        children: output
    });
    return output;
};
const getVariables = (text, values)=>{
    const variables = [];
    for(let m = VAR_RE.exec(text); m !== null; m = VAR_RE.exec(text)){
        const [full, variableKey, variableFlag] = m;
        variables.push({
            from: m.index,
            to: m.index + full.length,
            previousValue: full,
            renderedValue: renderVariable(variableKey, variableFlag, values)
        });
    }
    return variables;
};
const getLinks = (text, values, linkRenderers)=>{
    const links = [];
    for(let m = LINK_RE.exec(text); m !== null; m = LINK_RE.exec(text)){
        const [full, attribute, hrefKey, inner] = m;
        links.push({
            from: m.index,
            to: m.index + full.length,
            previousValue: full,
            renderedValue: renderLink(attribute, hrefKey, inner, values, linkRenderers)
        });
    }
    return links;
};
const renderNodes = (text, values, linkRenderers)=>{
    const spans = [
        ...getVariables(text, values),
        ...getLinks(text, values, linkRenderers)
    ].sort((a, b)=>a.from - b.from);
    return spans.reduce((out, span, i)=>{
        const prevTo = i > 0 ? spans[i - 1].to : 0;
        if (span.from > prevTo) {
            out.push(text.slice(prevTo, span.from));
        }
        out.push(span.renderedValue);
        if (i === spans.length - 1 && span.to < text.length) {
            out.push(text.slice(span.to));
        }
        return out;
    }, spans.length === 0 ? [
        text
    ] : []);
};
export const formatLocalizationResource = (localizationResources, resourceKey, values = undefined, linkRenderers = undefined)=>{
    const message = get(localizationResources, resourceKey);
    if (!message) {
        return null;
    }
    const nodes = renderNodes(message.value, values, linkRenderers);
    // eslint-disable-next-line react/no-array-index-key
    return nodes.map((n, i)=>/*#__PURE__*/ _jsx(React.Fragment, {
            children: n
        }, i));
};
